<template>
  <div class="text-center">
    <v-dialog
      v-model="$store.projectsStore.state.newCompanyModal"
      max-width="560"
      max-height="98vh"
      content-class="new-company-dialog"
      persistent
    >
      <v-card class="company-modal" elevation="0">

        <!-- Header -->
        <div class="modal-header">
          <div class="header-left">
            <div class="header-icon-wrap">
              <v-icon color="white" size="20">mdi-domain-plus</v-icon>
            </div>
            <div>
              <div class="modal-title">Creación de Empresa</div>
              <div class="modal-subtitle">Completa los datos para registrar una nueva empresa</div>
            </div>
          </div>
          <v-btn icon small @click="closeModal" class="close-btn">
            <v-icon color="rgba(255,255,255,0.7)" size="18">mdi-close</v-icon>
          </v-btn>
        </div>

        <!-- Body -->
        <div class="modal-body">
          <v-form ref="form" v-model="validform" class="form-wrapper">
            <div class="scroll-area">

              <!-- Logo -->
              <div class="avatar-section">
                <div class="avatar-preview" @click="triggerFileInput">
                  <img v-if="logoPreviewUrl" :src="logoPreviewUrl" alt="logo preview" />
                  <v-icon v-else size="30" color="#b0bedd">mdi-domain</v-icon>
                  <div class="avatar-overlay">
                    <v-icon size="16" color="white">mdi-camera-outline</v-icon>
                  </div>
                </div>
                <div class="avatar-info">
                  <div class="avatar-label">Logo de la empresa</div>
                  <div class="avatar-actions">
                    <button type="button" class="btn-link" @click="triggerFileInput">Seleccionar imagen</button>
                    <button v-if="newCompanyData.logo" type="button" class="btn-link danger" @click="removeLogo">Quitar</button>
                  </div>
                </div>
                <input
                  ref="logoInput"
                  type="file"
                  accept=".png,.jpg,.jpeg"
                  class="hidden-input"
                  @change="onLogoChange"
                />
              </div>

              <!-- Datos de la empresa -->
              <div class="section-label">
                <v-icon size="13" color="#2D4B95" class="mr-1">mdi-domain</v-icon>
                Datos de la empresa
              </div>
              <div class="field-grid">
                <div class="field-group span-2">
                  <label class="field-label">Nombre</label>
                  <v-text-field
                    v-model="newCompanyData.name"
                    placeholder="Ingrese nombre de la empresa"
                    outlined
                    dense
                    hide-details="auto"
                    :rules="requiredRule"
                    class="custom-field"
                  ></v-text-field>
                </div>
                <div class="field-group">
                  <label class="field-label">RUT</label>
                  <v-text-field
                    v-model="newCompanyData.rut"
                    placeholder="Ingrese RUT de la empresa"
                    outlined
                    dense
                    hide-details="auto"
                    :rules="requiredRule"
                    class="custom-field"
                  ></v-text-field>
                </div>
                <div class="field-group">
                  <label class="field-label">Url sitio web</label>
                  <v-text-field
                    v-model="newCompanyData.url"
                    placeholder="Ingrese sitio web de la empresa"
                    outlined
                    dense
                    hide-details="auto"
                    class="custom-field"
                  ></v-text-field>
                </div>
                <div class="field-group span-2">
                  <label class="field-label">Descripción</label>
                  <v-text-field
                    v-model="newCompanyData.description"
                    placeholder="Ingrese descripción de la empresa"
                    outlined
                    dense
                    hide-details="auto"
                    :rules="requiredRule"
                    class="custom-field"
                  ></v-text-field>
                </div>
              </div>

            </div>
          </v-form>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
          <button class="btn-cancel" @click="closeModal">Cancelar</button>
          <button class="btn-save" :disabled="loadingData" @click="sendForm">
            <v-progress-circular v-if="loadingData" indeterminate size="15" width="2" color="white" class="mr-1"></v-progress-circular>
            <v-icon v-else size="15" color="white" class="mr-1">mdi-check</v-icon>
            Confirmar
          </button>
        </div>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {create} from '@/helpers/api/company'
export default {
  name: 'NewCompanyModal',
  data: () => ({
    validform: true,
    newCompanyData: {
      name: null,
      rut: null,
      description: null,
      url: null,
      logo: null,
    },
    logoPreviewUrl: null,
    loadingData: false,
    requiredRule: [
      v => !!v || 'Campo requerido'
    ],
  }),
  watch: {
    'newCompanyData.logo'(file){
      if(this.logoPreviewUrl){
        URL.revokeObjectURL(this.logoPreviewUrl)
        this.logoPreviewUrl = null
      }
      if(file){
        this.logoPreviewUrl = URL.createObjectURL(file)
      }
    }
  },
  mounted(){
  },
  methods: {
    triggerFileInput(){
      this.$refs.logoInput.click()
    },
    onLogoChange(event){
      const file = event.target.files[0]
      if(file){
        this.newCompanyData.logo = file
      }
      event.target.value = ''
    },
    removeLogo(){
      this.newCompanyData.logo = null
    },
    closeModal(){
      this.$store.projectsStore.commit('setNewCompanyModal', false)
      this.newCompanyData = {
        name: null,
        rut: null,
        description: null,
        url: null,
        logo: null,
      }
      this.validform = true
      this.loadingData = false
    },
    async sendForm(){
      if(this.$refs.form.validate()){
        this.loadingData = true
        try {
          const formData = new FormData()
          Object.keys(this.newCompanyData).forEach((key) => {
            if(this.newCompanyData[key]){
              formData.append(key, this.newCompanyData[key])
            }
          })
          const company = await create(formData)
          if(company.code === 200){
            const membership = {
              ...company.membership,
              company: company.company,
            }
            const companies = [
              ...this.$store.userStore.state.userCompanies,
              membership,
            ]
            this.$store.userStore.commit('setUserCompanies', companies)
            this.$store.userStore.commit('setSelectedCompany', membership)
            this.$store.userStore.commit('setSelectedCompanyMembership', membership)
            this.$store.userStore.commit('setCompanyPermissions', membership.capabilities)
            this.$root.$emit('company-created', membership)
            this.closeModal()
          }
        } catch (error) {
          this.notifyError(error)
        } finally {
          this.loadingData = false
        }
      }
    },
    notifyError(error) {
      const response = error && error.response ? error.response : error
      const data = response && response.data ? response.data : {}
      const rutErrors = data.errors && data.errors.rut ? data.errors.rut : []
      const errorMessages = {
        'validation.unique': 'El RUT ya está registrado para otra empresa.'
      }
      const rutMessage = rutErrors[0]
      const message = errorMessages[rutMessage] || rutMessage || data.message || 'No fue posible crear la empresa.'

      this.$store.globalStore.dispatch('addMessage', {
        message,
        title: 'Error',
        created: new Date(),
        type: 'error',
        icon: 'mdi-alert-circle',
        color: '#F4516C'
      })
    }
  }
};
</script>

<style scoped>
* { box-sizing: border-box; }

.company-modal {
  border-radius: 16px !important;
  overflow: hidden;
  background: #ffffff;
  display: flex !important;
  flex-direction: column !important;
  max-height: 98vh;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 22px 16px;
  background: linear-gradient(135deg, #2D4B95 0%, #1a2f63 100%);
  flex-shrink: 0;
}
.header-left { display: flex; align-items: center; gap: 12px; }
.header-icon-wrap {
  width: 36px; height: 36px; border-radius: 10px;
  background: rgba(255,255,255,0.15);
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.modal-title { font-size: 14px; font-weight: 600; color: #fff; line-height: 1.2; }
.modal-subtitle { font-size: 11px; color: rgba(255,255,255,0.6); margin-top: 2px; }
.close-btn { background: rgba(255,255,255,0.1) !important; border-radius: 8px !important; }

.modal-body {
  padding: 0;
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.form-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
}
.scroll-area {
  overflow-y: auto;
  padding: 20px 22px 20px;
  flex: 1 1 auto;
  min-height: 0;
}

.section-label {
  font-size: 11px; font-weight: 600; color: #2D4B95;
  text-transform: uppercase; letter-spacing: 0.07em;
  display: flex; align-items: center; margin-bottom: 12px;
}

/* Logo */
.avatar-section {
  display: flex; align-items: center; gap: 14px;
  padding: 14px 15px; border-radius: 12px;
  border: 1.5px solid #e2e8f4; background: #f7f9fc;
  margin-bottom: 20px;
}
.avatar-preview {
  position: relative; width: 60px; height: 60px; border-radius: 50%;
  background: #eef2fb; border: 1.5px solid #d1d9e8;
  display: flex; align-items: center; justify-content: center;
  overflow: hidden; cursor: pointer; flex-shrink: 0;
}
.avatar-preview img { width: 100%; height: 100%; object-fit: cover; }
.avatar-overlay {
  position: absolute; inset: 0; border-radius: 50%;
  background: rgba(26,47,99,0.45);
  display: flex; align-items: center; justify-content: center;
  opacity: 0; transition: opacity 0.15s;
}
.avatar-preview:hover .avatar-overlay { opacity: 1; }
.avatar-info { display: flex; flex-direction: column; gap: 4px; }
.avatar-label { font-size: 13px; font-weight: 600; color: #2d3748; }
.avatar-actions { display: flex; align-items: center; gap: 12px; }
.btn-link {
  background: none; border: none; padding: 0; cursor: pointer;
  font-size: 12px; font-weight: 600; color: #2D4B95;
}
.btn-link:hover { text-decoration: underline; }
.btn-link.danger { color: #F4516C; }
.hidden-input { display: none; }

/* Field grid */
.field-grid {
  display: grid; grid-template-columns: 1fr 1fr;
  gap: 14px 16px; margin-bottom: 4px;
}
.field-group { display: flex; flex-direction: column; }
.field-group.span-2 { grid-column: span 2; }
.field-label {
  font-size: 12px; font-weight: 600; color: #5a6a8a;
  margin-bottom: 6px;
}

/deep/ .custom-field .v-input__slot { border-radius: 8px !important; min-height: 40px; }
/deep/ .custom-field.v-text-field--outlined fieldset { border-color: #e2e8f4; border-width: 1.5px; }
/deep/ .custom-field.v-text-field--outlined.v-input--is-focused fieldset { border-color: #2D4B95 !important; }
/deep/ .custom-field input, /deep/ .custom-field .v-select__selection { font-size: 13px; color: #2d3748; }
/deep/ .custom-field .v-text-field__slot input::placeholder { color: #a4b0c9; }
/deep/ .custom-field.error--text fieldset { border-color: #F4516C !important; }

/* Footer */
.modal-footer {
  display: flex; align-items: center; justify-content: flex-end;
  gap: 8px; padding: 13px 22px;
  border-top: 1px solid #e8edf5; background: #f7f9fc;
}
.btn-cancel {
  padding: 8px 16px; border-radius: 8px;
  border: 1.5px solid #d1d9e8; background: transparent;
  font-size: 13px; font-weight: 500; color: #5a6a8a; cursor: pointer;
}
.btn-cancel:hover { background: #eef2fb; border-color: #b0bedd; }
.btn-save {
  display: flex; align-items: center;
  padding: 8px 18px; border-radius: 8px; border: none;
  background: linear-gradient(135deg, #2D4B95, #1a2f63);
  font-size: 13px; font-weight: 600; color: white;
  cursor: pointer; box-shadow: 0 3px 10px rgba(45,75,149,0.3);
}
.btn-save:hover:not(:disabled) { box-shadow: 0 5px 14px rgba(45,75,149,0.4); }
.btn-save:disabled { opacity: 0.6; cursor: not-allowed; box-shadow: none; }

@media (max-width: 600px) {
  .field-grid { grid-template-columns: 1fr; }
  .field-group.span-2 { grid-column: span 1; }
}
</style>

<style>
/* v-dialog aplica max-height: 90% por defecto (teleportado fuera del scope del componente) */
.new-company-dialog.v-dialog {
  max-height: 98vh;
}
</style>